export enum ReportEmailConditionalOperator {
  'Greater than' = '>',
  'Greater than or equal to' = '>=',
  'Less than' = '<',
  'Less than or equal to' = '<=',
  'Is equal to' = '==',
  'Is not equal to' = '!=='
}
